import Component from '@glimmer/component';
import styles from './styles.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface XFormMultipleChoiceArgs {}

export default class XFormMultipleChoice extends Component<XFormMultipleChoiceArgs> {
  styles = styles;
}
